"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePickerCardTranslations = {
    "en": {
        today: "Today",
        yesterday: "Yesterday",
        hourlyComparison: "(hourly comparison)",
        dailyComparison: "(daily comparison)",
        lastThreeDays: "Last 3 days",
        lastTwoWeeks: "Last 2 weeks",
        lastFourteenDays: "Last 14 days",
        lastWeek: "Last week",
        lastMonth: "Last month",
        custom: "Custom",
        archivedReports: "Archived Reports",
        archivedReportsTooltipOne: "Dates in",
        archivedReportsTooltipTwo: "are available in the monthly Archived reports",
        red: "red",
    },
    "de": {
        dailyComparison: "(täglicher Vergleich)",
        lastThreeDays: "Letzte 3 Tage",
        custom: "Benutzerdefiniert",
        lastMonth: "Letzter Monat",
        lastTwoWeeks: "Letzte 2 Wochen",
        archivedReports: "Archivierte Berichte",
        lastWeek: "Letzte Woche",
        yesterday: "Gestern",
        red: "rot",
        archivedReportsTooltipTwo: "sind in den monatlich archivierten Berichten verfügbar",
        archivedReportsTooltipOne: "Daten in",
        lastFourteenDays: "Letzte 14 Tage",
        today: "Heute",
        hourlyComparison: "(stündlicher Vergleich)",
    },
    "nl": {
        dailyComparison: "(vergelijking per dag)",
        lastThreeDays: "Laatste 3 dagen",
        custom: "Aangepast",
        lastMonth: "Laatste maand",
        lastTwoWeeks: "Afgelopen 2 weken",
        archivedReports: "Gearchiveerde rapporten",
        lastWeek: "Afgelopen week",
        yesterday: "Gisteren",
        red: "rood",
        archivedReportsTooltipTwo: "zijn beschikbaar in de maandelijkse gearchiveerde rapporten",
        archivedReportsTooltipOne: "Data in",
        lastFourteenDays: "Laatste 14 dagen",
        today: "Vandaag",
        hourlyComparison: "(vergelijking per uur)",
    },
    "it": {
        dailyComparison: "(confronto giornaliero)",
        lastThreeDays: "Ultimi 3 giorni",
        custom: "Personalizzato",
        lastMonth: "Ultimo mese",
        lastTwoWeeks: "Ultime 2 settimane",
        archivedReports: "Rapporti archiviati",
        lastWeek: "Ultima settimana",
        yesterday: "Ieri",
        red: "rosso",
        archivedReportsTooltipTwo: "sono disponibili nei rapporti mensili archiviati",
        archivedReportsTooltipOne: "Date in",
        lastFourteenDays: "Ultimi 14 giorni",
        today: "Oggi",
        hourlyComparison: "(confronto orario)",
    },
    "fr": {
        dailyComparison: "(comparaison quotidienne)",
        lastThreeDays: "Les 3 derniers jours",
        custom: "Personnalisé",
        lastMonth: "Le mois dernier",
        lastTwoWeeks: "Les 2 dernières semaines",
        archivedReports: "Rapports archivés",
        lastWeek: "La semaine dernière",
        yesterday: "Hier",
        red: "rouge",
        archivedReportsTooltipTwo: "sont disponibles dans les rapports archivés mensuels",
        archivedReportsTooltipOne: "Les dates en",
        lastFourteenDays: "Les 14 derniers jours",
        today: "Aujourd'hui",
        hourlyComparison: "(comparaison horaire)",
    },
    "es": {
        dailyComparison: "(comparación por día)",
        lastThreeDays: "Últimos 3 días",
        custom: "Personalizado",
        lastMonth: "Último mes",
        lastTwoWeeks: "Últimas 2 semanas",
        archivedReports: "Informes archivados",
        lastWeek: "Última semana",
        yesterday: "Ayer",
        red: "rojo",
        archivedReportsTooltipTwo: "está(n) disponible(s) en los informes mensuales archivados ",
        archivedReportsTooltipOne: "La(s) fecha(s) de inicio",
        lastFourteenDays: "Últimos 14 días",
        today: "Hoy",
        hourlyComparison: "(comparación por hora)",
    },
    "ja": {
        dailyComparison: "（日次比較）",
        lastThreeDays: "最近3日間",
        custom: "カスタム",
        lastMonth: "先月",
        lastTwoWeeks: "最近2週間",
        archivedReports: "アーカイブ済み報告書",
        lastWeek: "先週",
        yesterday: "昨日",
        red: "赤色",
        archivedReportsTooltipTwo: "は月次のアーカイブ済み報告書で使用可能です。",
        archivedReportsTooltipOne: "日付",
        lastFourteenDays: "最近14日間",
        today: "今日",
        hourlyComparison: "（時間単位比較）",
    },
    "en-GB": {
        dailyComparison: "(daily comparison)",
        lastThreeDays: "Last 3 days",
        custom: "Custom",
        lastMonth: "Last month",
        lastTwoWeeks: "Last 2 weeks",
        archivedReports: "Archived Reports",
        lastWeek: "Last week",
        yesterday: "Yesterday",
        red: "red",
        archivedReportsTooltipTwo: "are available in the monthly Archived reports",
        archivedReportsTooltipOne: "Dates in",
        lastFourteenDays: "Last 14 days",
        today: "Today",
        hourlyComparison: "(hourly comparison)",
    },
    "ru": {
        today: "Сегодня",
        yesterday: "Вчера",
        hourlyComparison: "(сравнение в часах)",
        dailyComparison: "(сравнение в днях)",
        lastThreeDays: "Последние 3 дня",
        lastTwoWeeks: "Последние 2 недели",
        lastFourteenDays: "Последние 14 дней",
        lastWeek: "Последняя неделя",
        lastMonth: "Последний месяц",
        custom: "Заданный",
        archivedReports: "Заархивированные Репорты",
        archivedReportsTooltipOne: "Даты",
        archivedReportsTooltipTwo: " цвета доступны в Заархивированных репортах за месяц",
        red: "красного",
    },
};
